// Module
var code = `<div class="js-group-panel {{subclass}}">
    <div class="js-group-panel-left-container"></div>
    {{#if .showRightContainer}}
    <div class="js-group-panel-right-container"></div>
    {{/if}}
</div>`;
// Exports
export default code;